import { useTranslation } from 'react-i18next';
import { ErrorDisplayStrings } from 'shared/utils/errors/errorDisplayUtils';

/**
 * Localized copy for classified error types, consumed by useErrorDisplay.
 */
export const useErrorDisplayStrings = (): ErrorDisplayStrings & {
  tryAgainButtonTitle: string;
  logOutButtonTitle: string;
  waitCountdownTemplate: (seconds: number) => string;
} => {
  const { t: translatedText } = useTranslation('sharedError');

  return {
    defaultTitle: translatedText('title.default'),
    defaultMessage: translatedText('message.default'),
    errorCopy: {
      network: {
        title: translatedText('errorCopy.network.title'),
        message: translatedText('errorCopy.network.message'),
      },
      server: {
        title: translatedText('errorCopy.server.title'),
        message: translatedText('errorCopy.server.message'),
      },
      client: {
        title: translatedText('errorCopy.client.title'),
        message: translatedText('errorCopy.client.message'),
      },
      timeout: {
        title: translatedText('errorCopy.timeout.title'),
        message: translatedText('errorCopy.timeout.message'),
      },
      graphql: {
        title: translatedText('errorCopy.graphql.title'),
        message: translatedText('errorCopy.graphql.message'),
      },
    },
    tryAgainButtonTitle: translatedText('buttons.tryAgain'),
    logOutButtonTitle: translatedText('buttons.logOut'),
    waitCountdownTemplate: (seconds: number) =>
      translatedText('buttons.waitCountdown', { seconds }),
  };
};
